export const addError = error => ({
  type: 'ADD_ERROR',
  error,
});
